import { FC } from 'react';
import IframeStyledHOC from './IframeStyledHOC';
import { IframeStyled, Root } from './style';
import { Props } from './types';

const Iframe: FC<Props> = ({ src, logoSrc, useModernPlayer, ...rest }) => {
  return (
    <Root>
      {useModernPlayer ? (
        <IframeStyledHOC width="100%" height="100%" src={src} onLoad={() => {}} {...rest} />
      ) : (
        <IframeStyled width="100%" height="100%" src={src} allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen; camera; microphone; clipboard-read; clipboard-write; display-capture; geolocation; xr-spatial-tracking" onLoad={() => {}} {...rest} />
      )}
    </Root>
  );
};

export default Iframe;
